import { Route } from 'lucide-react';
import { SimpleCrudPage } from './_SimpleCrudPage';
import { rounds, vehicles, type Round } from '../hooks/useArbreapains';

export function RoundsPage() {
  const { data: vehiclesList } = vehicles.useList();

  return (
    <SimpleCrudPage<Round>
      title="Tournées"
      itemLabel="tournée"
      icon={<Route size={18} />}
      query={rounds.useList()}
      createMut={rounds.useCreate() as never}
      updateMut={rounds.useUpdate() as never}
      deleteMut={rounds.useDelete()}
      fields={[
        { key: 'name', label: 'Nom', required: true, placeholder: 'Tournée Nord' },
        { key: 'description', label: 'Description', placeholder: 'Détails clients, secteur…' },
        { key: 'start_time', label: 'Heure de début', type: 'time' },
        { key: 'end_time', label: 'Heure de fin', type: 'time' },
        {
          key: 'vehicle_id',
          label: 'Véhicule par défaut',
          type: 'select',
          options: (vehiclesList ?? []).map((v) => ({
            value: String(v.id),
            label: v.license_plate ? `${v.name} · ${v.license_plate}` : v.name,
          })),
        },
      ]}
      renderExtra={(r) => (
        <>
          {r.start_time && r.end_time && (
            <p className="text-xs text-stone-500 mt-0.5">
              {r.start_time}–{r.end_time}
            </p>
          )}
          {r.description ? (
            <p className="text-xs text-stone-500 mt-0.5 line-clamp-2">{r.description}</p>
          ) : null}
        </>
      )}
    />
  );
}
